/**
 * Compares the card answer and user reponse, ignoring case.
 */
export function checkWrittenAnswer(answer: string, response: string): boolean {
  const lcAnswer = answer.toLocaleLowerCase();
  const lcResponse = response.toLocaleLowerCase();

  return lcAnswer === lcResponse;
}
